import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
const BEFORE = ['Cada caso complejo te hace dudar.', 'Revisas varias veces el mismo diagnóstico.', 'No sabes si confiar en la cara o en la cefalometría.', 'Temes pasar por alto detalles importantes.', 'Algunos tratamientos terminan complicándose.', 'Presentas tus planes con cierta inseguridad.'];
const AFTER = ['Sigues un proceso claro desde el primer minuto.', 'Tomas decisiones con mayor rapidez y seguridad.', 'Integras ambos análisis con criterio clínico.', 'Detectas señales clínicas antes de iniciar el tratamiento.', 'Planificas con mayor claridad desde el inicio.', 'Explicas tus decisiones con confianza y respaldo clínico.'];
export function Comparison() {
  return <section className="w-full bg-cream px-4 py-14 sm:py-20" data-id="element-95" data-mp="2800hsiumjrho">
      <div className="mx-auto max-w-3xl" data-id="element-96" data-mp="230nvbz7o0mfm">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-97" data-mp="231p8qac5ll0i">
          De la incertidumbre diagnóstica…
          <span className="mt-1 block text-gold-600" data-id="element-98" data-mp="3pa6xw85psxdh">
            a un proceso clínico que te permite decidir con confianza.
          </span>
        </h2>

        <div className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-99" data-mp="3bkvcb6fahrl6">
          <div className="rounded-3xl border border-red-100 bg-white p-5" data-id="element-100" data-mp="3ghc01ziku3xq">
            <p className="mb-4 flex items-center gap-2 text-[12.5px] font-bold uppercase tracking-[0.12em] text-red-500" data-id="element-101" data-mp="82bqaln7fhyt">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-red-50" data-id="element-102" data-mp="c46sdscylzdn">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-103" data-mp="3uabedy6mhs3p" />
              </span>
              Antes
            </p>
            <ul className="space-y-3" data-id="element-104" data-mp="31xi93lls80s">
              {BEFORE.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-105" data-mp="2iu3igflp5f10">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-106" data-mp="2ntg6v4s7uu5p" />
                  <span className="text-[14px] leading-snug text-navy-600" data-id="element-107" data-mp="23rbv3i5e9zi5">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-navy-800 bg-navy-800 p-5" data-id="element-108" data-mp="1zr1cn60f1gme">
            <p className="mb-4 flex items-center gap-2 text-[12.5px] font-bold uppercase tracking-[0.12em] text-gold-300" data-id="element-109" data-mp="1uy8c6ubzcug4">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/10" data-id="element-110" data-mp="1pzf63mz0w5pz">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="1l2eyh7miyuwr" />
              </span>
              Después del sistema
            </p>
            <ul className="space-y-3" data-id="element-112" data-mp="1c05r2qmjzhnl">
              {AFTER.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-113" data-mp="1c29sn1wzc4kp">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-114" data-mp="172dydue33ric" />
                  <span className="text-[14px] font-medium leading-snug text-white/90" data-id="element-115" data-mp="36cvm5bonqwwk">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <TransformCta headline="Da el paso del “Antes” al “Después” en tu próximo paciente." label="Quiero mi proceso claro hoy" location="comparacion" data-id="element-116" data-mp="38zeeofdjbvz5" />
      </div>
    </section>;
}